import {Module, NextModule} from '@backstage-components/base';
import React from 'react';
import {ButtonComponent, ButtonComponentDefinition} from './ButtonComponent';
import {ComponentDefinition} from './ButtonDefinition';

type Kind = ButtonComponentDefinition['component'];

type Props = ButtonComponentDefinition['props'];

export const ButtonModule: Module<Kind, Props> = {
  isContent(value): value is ButtonComponentDefinition {
    return (
      value.component === ComponentDefinition.reactName &&
      value.cid === ComponentDefinition.id
    );
  },
  isLayout(value): value is ButtonComponentDefinition {
    return false;
  },
  tryRender(definition) {
    if (ButtonModule.isContent(definition)) {
      return React.createElement(ButtonComponent, definition);
    } else {
      return NextModule;
    }
  },
};
